import moment from 'moment'
import router from '../../router'

export const dashboard = {
    state: {
        dashboard: null,
        dashboardInactiveServices: null,
        status: 'idle',
        inactiveServicesStatus: 'idle',
        receiptCount: null,
        snippets: null
    },
    mutations: {
        SET_DASHBOARD_STATUS(state, payload) {
            state.status = payload
        },
        SET_DASHBOARD_INACTIVE_SERVICES_STATUS(state, payload) {
            state.inactiveServicesStatus = payload
        },
        SET_RECEIPTCOUNT(state, payload) {
            state.receiptCount = payload
        },
        SET_DASHBOARD(state, payload) {
            state.dashboard = payload
        },
        SET_DASHBOARD_INACTIVE_SERVICES(state, payload) {
            state.dashboardInactiveServices = payload
        },
        SET_DASHBOARD_SNIPPETS(state, payload) {
            let snippetContent = ''
            if (payload.snippetContentResponseList) {
                payload.snippetContentResponseList.forEach(el => {
                    snippetContent += el.content.replace(/^<p>|<\/p>$/g, '')
                })
            }
            state.snippets = snippetContent
        }
    },
    actions: {
        async dashboardStatsFetch({ commit }) {
            try {
                commit('SET_DASHBOARD_STATUS', 'loading')

                const { status, data } = await this.$api.get('dashboard/sums')

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Failed GET dashboard/sums')
                }

                commit('SET_DASHBOARD', data.data)
            } catch (error) {
                console.log(error)
            } finally {
                commit('SET_DASHBOARD_STATUS', 'idle')
            }
        },
        async dashboardInactiveServicesFetch({ commit }) {
            try {
                commit('SET_DASHBOARD_INACTIVE_SERVICES_STATUS', 'loading')

                const { status, data } = await this.$api.get('dashboard_widget_inactive_services')

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Failed GET dashboard_widget_inactive_services')
                }
                commit('SET_DASHBOARD_INACTIVE_SERVICES', data.data)
            } catch (error) {
                console.log(error)
            } finally {
                commit('SET_DASHBOARD_INACTIVE_SERVICES_STATUS', 'idle')
            }
        },
        async receiptCountFetch({ commit, getters }) {
            let response = {}
            if (getters.isLotteryUser) {
                response = await this.$api.get('/lottery/get/receiptCount')
            } else {
                response = await this.$api.post('statistics/receiptCount', {
                    userId: getters.userId
                })
            }

            if (response.status === 200) {
                commit('SET_RECEIPTCOUNT', response.data.data)
            }
        },
        async goToNewPromos({ dispatch }) {
            await dispatch('clearFilters', 'promotions')
            await dispatch('setFilter', {
                filter: 'newPromos',
                value: true,
                moduleName: 'promotions'
            })
            router.push({ name: 'promo-list' })
        }
    },
    getters: {
        getReceiptAmount: state => {
            if (state.receiptCount) {
                return {
                    title: 'Suma sprzedaży paragonów w danym dniu',
                    colors: ['rgba(107,182,69,0.6)'],
                    categories: state.receiptCount.map(el =>
                        moment(el.data).format('D.MM')
                    ),
                    series: [
                        {
                            name: 'Sprzedaż w tym dniu',
                            data: state.receiptCount.map(el =>
                                (+el.amount).toFixed(2)
                            )
                        }
                    ]
                }
            }
        },
        getCompaniesChart: state => {
            if (state.dashboard) {
                // const companies = Object.keys(state.dashboard.companies).map(el => el !== 'SUM')
                delete state.dashboard.companies.SUM
            }
            return {
                title: 'Liczba aktywnych promocji danego organizatora',
                series: state.dashboard
                    ? Object.values(state.dashboard.companies)
                    : [],
                labels: state.dashboard
                    ? Object.keys(state.dashboard.companies)
                    : []
            }
        },
        getReceiptCount: state => {
            if (state.receiptCount) {
                return {
                    title: 'Wystawione paragony w danym dniu',
                    colors: ['rgba(225,81,0,0.6)'],
                    categories: state.receiptCount.map(el =>
                        moment(el.data).format('D.MM')
                    ),
                    series: [
                        {
                            name: 'Wystawione paragony w tym dniu',
                            data: state.receiptCount.map(el => el.cnt)
                        }
                    ]
                }
            }
        },
        getDashboard: state => {
            if (state.dashboard) {
                return state.dashboard
            }
        },
        getDashboardSnippets: state => {
            if (state.snippets) {
                return state.snippets
            }
        },
        getDashboardCards: (state, getters) => {
            moment().locale('pl')
            return [
                {
                    title: 'Nowe Promocje',
                    description:
                        'które pojawiły się od Twojej ostatniej wizyty',
                    value: state.dashboard && state.dashboard.new_promos.length,
                    action: 'goToNewPromos',
                    moduleName: 'promotions',
                    status: state.status
                },
                {
                    title: 'Suma aktywnych promocji',
                    description: 'w Twojej sieci sklepów',
                    value:
                        state.dashboard && state.dashboard.sum_active_promos
                            ? state.dashboard.sum_active_promos
                            : 0,
                    function: router.resolve({ name: 'promo-yours' }).href,
                    moduleName: 'promotions',
                    status: state.status
                },
                {
                    title: 'Kończące się promocje',
                    description: 'Najbliższe aktywne promocje kończą się',
                    value:
                        state.dashboard &&
                        state.dashboard.fastest_ending_promotion
                            ? moment(
                                state.dashboard.fastest_ending_promotion
                            ).format('DD MMM')
                            : null,
                    class: 'is-small',
                    function: router.resolve({ name: 'promo-yours' }).href,
                    moduleName: 'promotions',
                    setFilter: {
                        filter: 'endingPromos',
                        value: true
                    },
                    status: state.status
                },
                {
                    title: 'Włącz usługi',
                    description: 'Liczba usług, które możesz aktywować',
                    value:
                        state.dashboardInactiveServices?.inactive_services || 0,
                    function: router.resolve({ name: 'services' }).href,
                    isBtnHidden: getters.isShopUser,
                    status: state.inactiveServicesStatus
                }
            ]
        }
    }
}
